import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const ShopAccordion = withStyles({
  root: {
    boxShadow: 'none',
    borderRadius: 'none !important',
    margin: '0px !important',
    border: 'none',
    borderTop: '1px solid #E6E6E6',
    '&:before': {
      content: 'none',
    },
    '&:first-child': {
      borderTopRightRadius: '0px',
      borderTopLeftRadius: '0px',
    },
    '&:last-child': {
      borderBottom: '1px solid #E6E6E6',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
    },
  },
})(Accordion);

const ShopAccordionSummary = withStyles({
  root: {
    padding: 'unset',
  },
  content: {
    marginTop: '20px',
    marginBottom: '20px',
  },
})(AccordionSummary);

const ShopAccordionDetails = withStyles((theme) => ({
  root: {
    paddingLeft: 'unset',
    paddingRight: 'unset',
    paddingBottom: theme.spacing(5),
    flexDirection: 'column',
  },
}))(AccordionDetails);

export { ShopAccordion, ShopAccordionSummary, ShopAccordionDetails };
